const preStatus = [
    {
        name:'Semua',
        value:'preActive'
    },
    {
        name:'Tersimpan',
        value:'placed'
    },
    {
        name:'Terjadwal',
        value:'scheduled'
    }
]
export default preStatus